import { useClerk } from "@clerk/clerk-expo";
import { useMagicLinkTokens } from "@features/auth/hooks/useMagicLinkTokens";
import { useAuthProvider } from "@helpers/auth-provider";
import { captureErrorToSentry } from "@helpers/sentry-logger";
import useAuthUser from "@hooks/useAuthUser";
import { Stack } from "expo-router";
import { useEffect } from "react";

const ClerkAuthLayout = () => {
	const { isLoaded } = useAuthUser();
	const { sessionId } = useMagicLinkTokens();
	const { setActive } = useClerk();

	useEffect(() => {
		async function verify() {
			try {
				if (sessionId) {
					await setActive({ session: sessionId });
				}
			} catch (err: unknown) {
				const error = new Error("Email link verification error");
				captureErrorToSentry(error, { error: JSON.stringify(err) });
			}
		}
		verify();
	}, [sessionId, setActive]);

	if (!isLoaded) {
		return null;
	}

	return <Stack />;
};

const SupabaseAuthLayout = () => {
	return <Stack />;
};

export default function Layout() {
	const { isClerk } = useAuthProvider();
	if (isClerk) {
		return <ClerkAuthLayout />;
	}
	return <SupabaseAuthLayout />;
}
